import { createSagaActionTypes } from '../../../utils/actionFactory';

export const GET_PERMISSIONS = 'GET_PERMISSIONS';
export const DELETE_PERMISSION = 'DELETE_PERMISSION';

export const actions = createSagaActionTypes('PERMISSIONS', [
  GET_PERMISSIONS,
  DELETE_PERMISSION
]);
